import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { ArrowLeft, Building2 } from "lucide-react";
import FacilityInfo from "./FacilityInfo";
import "./ViewFacility.css";

const ViewFacility = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const facilityData = location.state?.data;

  return (
    <div style={{ margin: "8px", fontFamily: "'Poppins', 'Segoe UI', sans-serif" }}>
      <style>{`@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@500;600;700;800&display=swap');`}</style>
      <div className="facv-header-banner">
        <button type="button" className="facv-back-btn" onClick={() => navigate(-1)} aria-label="Back">
          <ArrowLeft size={16} />
        </button>
        <span className="facv-header-icon">
          <Building2 size={14} color="#fff" />
        </span>
        <div>
          <div className="facv-header-title">View Facility</div>
          <div className="facv-header-subtitle">Facility details and location</div>
        </div>
      </div>
      <FacilityInfo facilityData={facilityData} />
    </div>
  );
};

export default ViewFacility;
